import { render, staticRenderFns } from "./SpecialistBookingMenu.vue?vue&type=template&id=6e763030"
import script from "./SpecialistBookingMenu.vue?vue&type=script&lang=js"
export * from "./SpecialistBookingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports